import {Injectable} from '@angular/core';
import {Backend, SingleResponse} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import {ListItem} from '../../../entities/list-item.entity';
import TimeTrackingAbsenceRequest = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingAbsenceRequest;
import TimeTrackingAbsenceRequestData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingAbsenceRequestData;
import TimeTrackingAbsenceRequestProcessData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingAbsenceRequestProcessData;
import TimeTrackingAbsenceRequestCancelData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingAbsenceRequestCancelData;

@Injectable({providedIn: 'root'})
export class TimeTrackingAbsenceRequestService extends BaseEndpointService<TimeTrackingAbsenceRequest, TimeTrackingAbsenceRequestData> {
  protected override endpoint = '/time-tracking/absence-requests';

  public cancel(absenceRequest: TimeTrackingAbsenceRequest, data: TimeTrackingAbsenceRequestCancelData) {
    return this.http.put<SingleResponse<TimeTrackingAbsenceRequest>>(`${this.endpoint}/${absenceRequest.id}/cancel`, data);
  }

  public process(absenceRequest: TimeTrackingAbsenceRequest, data: TimeTrackingAbsenceRequestProcessData) {
    return this.http.put<SingleResponse<TimeTrackingAbsenceRequest>>(`${this.endpoint}/${absenceRequest.id}/process`, data);
  }

  public override modelToMultiSelectItem(m: TimeTrackingAbsenceRequest): ListItem & { model: TimeTrackingAbsenceRequest; } {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    }
  }
}
